import React, { useState } from 'react';
import LoginForm from './login';
import MobileVerification from './mobileVerification';
import LoginHeader from './loginHeader';
import SignupFooter from './signupFooter';
import VerifyMobileHeader from './verifyMobileHeader';

export default function LoginWithVerification({
  showForgot,
  showSignup,
  onSuccess
}) {
  const [verifyMobile, setVerifyMobile] = useState(false);

  function handleLoginSuccess(user) {
    if (user && user.mobile && !user.mobileVerified) {
      setVerifyMobile(true);
    } else if (onSuccess) {
      onSuccess();
    }
  }

  return verifyMobile ? (
    <>
      <VerifyMobileHeader />
      <MobileVerification onSuccess={onSuccess} />
    </>
  ) : (
    <>
      <LoginHeader />
      <LoginForm
        showForgotPassword={showForgot}
        onSuccess={handleLoginSuccess}
      />
      <SignupFooter showSignup={showSignup} />
    </>
  );
}
